import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { clientLogError } from '@/src/lib/clientLog'

import { CopyUrl } from '@/src/assets/icons'
import { copyTextToClipboard } from '@/src/helpers/clipboard'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

export const CopyUrlButton = () => {
  const { t } = useTranslation()
  const [copySuccess, setCopySuccess] = useState('')

  const copyToClipboard = async () => {
    try {
      setCopySuccess('Ссылка скопирована')

      await copyTextToClipboard(window.location.href)
      setTimeout(() => {
        setCopySuccess('')
      }, 2000)
    } catch (err) {
      console.error('Error with copying link to meet: \n', err)
      clientLogError(`Error with copying link to meet: \n${err}`)

      setCopySuccess('Ошибка копирования ссылки')
      setTimeout(() => {
        setCopySuccess('')
      }, 2000)
    }
  }

  const { text_primary_color, border_radius } = useAppSelector(selectBranding)

  return (
    <div className="lk-button-box" style={{ color: `${text_primary_color}` }}>
      <div className="lk-button-box-text">{copySuccess && <p>{copySuccess}</p>}</div>
      <button
        className="lk-button-box-button"
        style={{
          borderRadius: `${border_radius}px`,
          border: `1px solid ${text_primary_color}`,
        }}
        onClick={copyToClipboard}
      >
        <CopyUrl fill={text_primary_color} />
        <p style={{ color: `${text_primary_color}` }}>{t('copyLink')}</p>
      </button>
    </div>
  )
}
